import { FC, useCallback, useLayoutEffect, useRef, useState } from 'react';
import { BaseIntegrationModalProps } from 'src/redesign/pages/IntegrationsPage/types';
import S from './AdvancedConnectedModal.module.scss';
import { Text } from 'src/redesign/components/Text';
import { Input } from 'src/redesign/components/Input';
import { RedesignButton } from 'src/redesign/components/RedesignButton';
import { saveNewIntegration } from 'src/redesign/pages/IntegrationsPage/store/actions';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import c from 'clsx';
import { getAccountConnected } from 'src/redesign/features/Account/store/actions';
import { Loader } from 'wix-style-react';
import { closeCurrentModalAction } from 'src/redesign/features/Modals/store/reducer';
import { connectionIntegrationSelector } from 'src/redesign/pages/IntegrationsPage/store/selectors';

const ALLOWABLE_HEIGHT_THRESHOLD = 124;

export const AdvancedConnectedModal: FC<BaseIntegrationModalProps> = ({
  type,
  url,
  icon,
  information,
}) => {
  const dispatch = useAppDispatch();
  const [apiValue, setApiValue] = useState<string | undefined>();
  const [showExpandableButton, setShowExpandableButton] = useState(false);
  const loadingAccountConnected = useAppSelector(connectionIntegrationSelector);

  const informationRef = useRef<HTMLParagraphElement>(null);

  useLayoutEffect(() => {
    if (!informationRef.current) return;
    setShowExpandableButton(informationRef.current.clientHeight > ALLOWABLE_HEIGHT_THRESHOLD);
  }, []);

  const handleSave = useCallback(() => {
    dispatch(
      saveNewIntegration({
        integrationType: type,
        apiKey: apiValue,
      }),
    )
      .unwrap()
      .then(() => {
        dispatch(closeCurrentModalAction());
        dispatch(getAccountConnected());
      });
  }, [dispatch, type, apiValue]);

  return (
    <div className={S.advancedConnectedModal}>
      <div className={S.content}>
        <div className={S.iconWrapper}>{icon}</div>
        <div className={c(S.informationWrapper)}>
          <Text variation="body" ref={informationRef}>
            {information}
          </Text>
        </div>
      </div>
      <div className={S.form}>
        <>
          <Input
            value={apiValue}
            className={S.firstInput}
            onChange={(e) => setApiValue(e.target.value)}
            labelHook="integration-token"
            label="API Key"
          />
        </>
        <RedesignButton className={S.button} onClick={handleSave} variation="primary" height={44}>
          <Text variation="body" bold color="white-100">
            {loadingAccountConnected ? <Loader size="tiny" /> : 'Connect'}
          </Text>
        </RedesignButton>
      </div>
    </div>
  );
};
